import { CommonModule } from '@angular/common';
import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CouponService, ExcelService, OrganizationService } from '@fitness-force/api';
import { Status } from '@fitness-force/enum';
import { OfferMaster, ListOrganization, Organization, OfferEligibleOrganization, AddOrganisationRequest } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from '@fitness-force/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { ScrollPanelModule } from 'primeng/scrollpanel';

import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'coupon-organization-restriction',
  templateUrl: './coupon-organization-restriction.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollPanelModule,
    ButtonModule,
    SelectModule,
    TranslateModule
]
})
export class CouponOrganizationRestrictionComponent implements OnInit {
  @Input('tenantId') tenantId = 0;
  @Input('couponMaster') couponMaster: OfferMaster;
  @Input('visible') visible: boolean = false;
  @Input('organizationIds') organizationIds: number[] = [];
  @Output('closeEvent') closeEvent: EventEmitter<any> = new EventEmitter();

  organizationList: Organization[] = [];
  couponOrganization: OfferEligibleOrganization[] = [];
  selectedOrganization = new BehaviorSubject<OfferEligibleOrganization[]>([]);
  reloadList: boolean = false;

  constructor(private coupnService: CouponService,
    private translate: TranslateService,
    private excelService: ExcelService,
    private toastMessageService: ToastMessageService, private organizationService: OrganizationService) {
  }

  ngOnInit(): void {
    this.BindOrganizations();
  }


  BindOrganizations() {
    this.organizationService.ListOrganization(this.tenantId).subscribe({
      next: (res: ListOrganization) => {
        if (res.items)
          this.organizationList = res.items.filter((value: any) => value.status == Status.Active.toString() || value.status == Status[Status.Active]);
        else
          this.organizationList = [];
        this.getCouponEligibleOrganization();
      },
      error: (error: any) => { },
    });
  }

  getCouponEligibleOrganization() {
    this.coupnService.getEligibleOrganization(this.tenantId, this.couponMaster.id).subscribe({
      next: (res: any) => {
        if (res.items) {
          this.couponOrganization = res.items as OfferEligibleOrganization[];
          this.couponOrganization.forEach(o => {
            o.name_primary_language = this.organizationList.find(f => f.id == o.organisation_id)!.name_primary_language
          })
          this.selectedOrganization.next(this.couponOrganization);
        }
        else {
          this.selectedOrganization.next([]);
          this.couponOrganization = [];
        }
      },
      error: (error: any) => { },
    });
  }

  addOrganisations(event: any) {
    let payload: AddOrganisationRequest = {} as AddOrganisationRequest;
    payload.organisation_ids = [];
    payload.organisation_ids.push(event.value.id);
    this.coupnService.addEligibleOrganization(this.tenantId, this.couponMaster.id, payload).subscribe({
      next: (res: any) => {
        this.translate.get('ADMIN.COUPON.ERRORS.ORGANIZATION_ADDED')
          .subscribe((translation) => {
            this.toastMessageService.showSuccess(translation);
          });
        this.getCouponEligibleOrganization();
        this.reloadList = true;
      },
      error: (error: any) => {
        this.handleToastError(error);
      },
    });
  }

  removeOrganisation(offerEligibleOrganization: OfferEligibleOrganization) {
    if (this.couponOrganization && this.couponOrganization.length == 1) {
      this.translate.get('ADMIN.COUPON.ERRORS.ONE_ORGANIZATION_REQUIRED').subscribe((translation) => {
        this.toastMessageService.showErrorMessage(translation);
      });
    }
    else {
      this.coupnService.removeEligibleOrganization(this.tenantId, offerEligibleOrganization.offer_master_id, offerEligibleOrganization.id).subscribe({
        next: (res: any) => {
          this.translate.get('ADMIN.COUPON.ERRORS.ORGANIZATION_REMOVED')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.getCouponEligibleOrganization();
          this.reloadList = true;
        },
        error: (error: any) => {
          this.handleToastError(error);
        },
      });
    }
  }

  handleToastError(error: any) {
    if (error.originalError.error.length > 0) {
      error.originalError.error.forEach((e: any) => {
        this.toastMessageService.showErrorMessage(e);
      });
    } else {
      this.toastMessageService.showErrorMessage(error);
    }
  }

  closePopup() {
    this.visible = false;
    this.closeEvent.emit({ reload: this.reloadList });
  }

}
